import { SelectMenu } from '@hakimo-ui/hakimo/ui-elements';
import {
  StatusFilterValue,
  StatusFilterOption,
  STATUS_FILTER_OPTIONS,
} from '../types';

interface Props {
  value: StatusFilterValue;
  onChange: (value: StatusFilterValue) => void;
}

function StatusFilter(props: Props) {
  const { value, onChange } = props;

  const selectedOption = STATUS_FILTER_OPTIONS.find(
    (option) => option.value === value?.isEnabled
  );

  const handleChange = (option: StatusFilterOption) => {
    onChange({
      isEnabled: option.value,
    });
  };

  return (
    <SelectMenu
      label="Status"
      value={selectedOption}
      items={STATUS_FILTER_OPTIONS}
      onChange={handleChange}
      displayValue={(item) => item?.name || ''}
      id={(item) => item.id}
    />
  );
}

export default StatusFilter;
